import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_highlight_text_value = _resolveComponent("highlight-text-value");
  const _component_MarketplaceValue = _resolveComponent("MarketplaceValue");
  const _component_WrapWithSectionItem = _resolveComponent("WrapWithSectionItem");
  return _openBlock(), _createBlock(_component_WrapWithSectionItem, {
    selected: $props.selected,
    no_reset: $props.no_reset,
    onSelect: _cache[0] || (_cache[0] = $event => _ctx.$emit('select', $props.item)),
    onDeselect: _cache[1] || (_cache[1] = $event => _ctx.$emit('deselect', $props.item)),
    onSelectOnly: _cache[2] || (_cache[2] = $event => _ctx.$emit('selectOnly', $props.item))
  }, {
    default: _withCtx(() => [_createVNode(_component_MarketplaceValue, {
      style: {
        justifyContent: 'flex-start'
      },
      marketplace: $props.name,
      flag: $props.icon
    }, {
      value: _withCtx(({
        value
      }) => [_createVNode(_component_highlight_text_value, {
        id: "marketplace",
        value: value,
        query: $props.query
      }, null, 8, ["value", "query"])]),
      _: 1
    }, 8, ["marketplace", "flag"])]),
    _: 1
  }, 8, ["selected", "no_reset"]);
}